<div class="container-fluid">
  <div class="row mt-3">
    <div class="col-md-5 chess-board-Box"></div>
    <div class="col-md-12 table-box">
      <div class="">
        <div class="opening-filter d-flex justify-content-center">
          <form class="mt-3" style="width: 90%" [formGroup]="openingFilters"
            (ngSubmit)="filterData(openingFilters.value)">
            <div class="row">
              <div class="form-group col-md-6">
                <label for="inputEmail4" class="game-histroy-font-color mb-1">Opening</label>
                <input type="text" class="form-control" formControlName="name" placeholder="Enter Opening"
                  [(ngModel)]="openingName" (keyup)="playerInputChanges($event)" required />
                @if(openingsuggestions.length > 0){
                <ul class="list-group search-Box mt-1">
                  @for (item of openingsuggestions; track $index) {
                  <li class="list-group-item p-1" style="cursor: pointer;" (click)="suggestionValue(item.name)">
                    {{ item.name }}
                  </li>
                  }
                </ul>
                }
              </div>
              <div class="form-group col-md-6">
                <label for="inputEmail4" class="game-histroy-font-color mb-1">Eco</label>
                <input type="text" class="form-control" formControlName="eco" placeholder="eco" required />
              </div>
            </div>

            <div class="d-flex justify-content-center m-3">
              <button type="submit" class="btn serach-btn">Search</button>
              <button type="button" class="btn reset-btn ms-3" (click)="formReset()">
                Reset
              </button>
            </div>
          </form>
        </div>
        <div class="table-responsive my-4" (scroll)="onScroll($event)">
          <table class="table table-striped mb-0">
            <thead class="table-head">
              <tr class="table-header table-header-sticky">
                <th class="col-1">No.</th>
                <th class="col-1">Eco</th>
                <th class="col-5">Opening</th>
                <th class="col-5">pgn</th>
              </tr>
            </thead>
            <tbody style="border-color: rgb(106 106 126)">
              @for (records of openingRecord; track $index) {
              <tr (click)="openingSelectData(records)" style="cursor: pointer">
                <td>{{ $index + 1 }}</td>
                <td>{{ records.eco }}</td>
                <td>{{ records.name }}</td>
                <td>
                  <p class="m-0" [innerHTML]="records.pgn | pieceIcon">{{ records.pgn }}</p>
                </td>
              </tr>

              }@if(isLoading) {
              <tr>
                <td colspan="4">
                  <div class="d-flex justify-content-center">
                    <p class="loader ms-3 m-0"></p>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>